export class Contact {
  constructor(
    public name?: string,
    public phone?: string,
    public email?: string,
    public message?: string
  ) {}
}